"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RadioOption", {
  enumerable: true,
  get: function get() {
    return _radioOption["default"];
  }
});
Object.defineProperty(exports, "RadioInline", {
  enumerable: true,
  get: function get() {
    return _radioInline["default"];
  }
});
Object.defineProperty(exports, "RadioBlock", {
  enumerable: true,
  get: function get() {
    return _radioBlock["default"];
  }
});
exports["default"] = void 0;

var _radioOption = _interopRequireDefault(require("./radio-option"));

var _radioGroup = _interopRequireDefault(require("./radio-group"));

var _radioInline = _interopRequireDefault(require("./radio-inline"));

var _radioBlock = _interopRequireDefault(require("./radio-block"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @deprecated
 */

/**
 * @deprecated
 */
var _default = _radioGroup["default"];
exports["default"] = _default;